<template>
    <div style="padding-bottom: 65px; box-sizing: border-box">
        <!-- 功能按钮 -->
        <div
            style="
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                justify-content: space-between;
                padding: 0 10px;
                box-sizing: border-box;
            "
        >
            <div style="display: flex; align-items: center; flex-wrap: wrap">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : firstPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="prev == null ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : prevPage()"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : nextPage()"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="next == null ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : lastPage()"
                />
            </div>
            <div style="display: flex; align-items: center; flex-wrap: wrap">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="add"
                    :disabled="isAdd || !isedit"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOver"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}</el-button
                >

                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>

                <el-button
                    type="primary"
                    size="mini"
                    :disabled="isAdd || !isedit || nullBtn"
                    @click="printOut"
                    v-if="perData.allow_print == 1"
                    icon="el-icon-printer"
                >{{ $t('common.print') }}</el-button
                >
                <el-button type="primary" :disabled="isAdd || !isedit" plain @click="isEdit(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}</el-button>
            </div>
        </div>
        <!-- 制单信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 单据主表 -->
        <div class="top_cols">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billNo') + '：'">
                            <el-input v-model="form.balprc_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billDate') + '：'" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.balprc_date"
                                @change="billDateChange"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.customer') + '：'" required>
                            <mySelectOptimized
                                v-model="form.cust_no"
                                :options="allArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                :disable="isedit"
                                @input="selectCust"
                                @selectChange="selectCustChange"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.billType') + '：'" required>
                            <el-select
                                v-model="form.billtype_no"
                                filterable
                                default-first-option
                                clearable
                                @change="refreshs()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.billtype"
                                    :key="index"
                                    :label="item.billtype_no + ' - ' + item.billtype_name"
                                    :value="item.billtype_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="$t('common.salesman') + '：'">
                            <el-select
                                v-model="form.salesman_no"
                                filterable
                                default-first-option
                                clearable
                                @change="refreshs()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.salesman"
                                    :key="index"
                                    :label="item.salesman_no + ' - ' + item.salesman_name"
                                    :value="item.salesman_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6">
                        <el-form-item :label="$t('common.currency') + '：'" required>
                            <el-select
                                v-model="form.currency_no"
                                filterable
                                default-first-option
                                clearable
                                @change="refreshs()"
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.currency"
                                    :key="index"
                                    :label="item.currency_no + ' - ' + item.currency_name"
                                    :value="item.currency_no.toString()"
                                    :disabled="item.status == 0"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 6 : 12">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <template>
            <div style="position: relative">
                <!-- 明细表和客户存欠并排显示 -->
                <div style="display: flex; gap: 5px;">
                    <!-- 明细表 -->
                    <div class="table1" @mouseleave="dtlleave" style="flex: 8;">
                        <div class="title">
                            <div style="text-align: left; color: #000; font-size: 16px; padding: 6px 0">
                                结价明细<span
                                style="font-size: 12px; color: #666">（注意：正数为欠料/欠钱、负数为存料/存钱）</span>
                            </div>
                        </div>
                        <vxe-table
                            border
                            stripe
                            resizable
                            keep-source
                            align="center"
                            ref="xTable1"
                            height="440"
                            show-overflow
                            :auto-resize="true"
                            show-footer-overflow
                            :footer-method="footerMethod"
                            show-footer
                            highlight-hover-row
                            :loading="loading"
                            :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isEdit: true, enterToTab: true }"
                            :row-class-name="rowChange"
                            :data="form.dtl"
                            :mouse-config="{ selected: true }"
                            :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                            @cell-mouseenter="dtlenter"
                            :key="refushTable"
                        >
                            <!-- <vxe-table-column type="checkbox" width="50"></vxe-table-column> -->
                            <vxe-table-column type="seq" field="seq" width="70" title="序号">
                                <template slot="header">
                                    <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                                </template>
                                <template slot-scope="scoped">
              <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
              </span>
                                    <span v-if="scoped.$rowIndex != dtlIndex">
                <i style="font-style: normal">{{ scoped.seq }}</i>
              </span>
                                </template>
                            </vxe-table-column>

                            <template v-for="(item, index) in rkKeyList">
                                <vxe-table-column
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                    :edit-render="{
                name: 'input',
                attrs: { type: item.column_type },
                autoselect: true,
                autofocus: '.vxe-input--inner'
              }"
                                    v-if="item.column_status == 1 && item.column_type != 'select' && item.field != 'amt'"
                                >
                                    <template v-slot:edit="{ row }">
                                        <vxe-input
                                            type="text"
                                            @input="handleInput(row, item.field, item.column_type)"
                                            @keydown.native="jumptable($event, row, item.field)"
                                            v-model="row[item.field]"
                                            @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                        ></vxe-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    v-if="item.column_status == 1 && item.column_type == 'select'"
                                    :title="item.column_name"
                                    :field="item.field"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                    :edit-render="{ autofocus: '.el-input__inner' }"
                                >
                                    <template #default="{ row }">
                <span>{{
                        $selectLable.selectLable(
                            row[item.field],
                            allArr[item.field.replace('_no', '')],
                            item.field,
                            item.field.replace('_no', '_name')
                        )
                    }}</span>
                                    </template>
                                    <template v-slot:edit="{ row }">
                                        <el-select
                                            size="mini"
                                            v-model="row[item.field]"
                                            ref="stylefocus"
                                            filterable
                                            default-first-option
                                            placeholder="请选择"
                                            @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                            @keydown.native="jumptable($event, row, item.field)"
                                        >
                                            <el-option
                                                v-for="option in allArr[item.field.replace('_no', '')] || []"
                                                :key="option[item.field.replace('_no', '') + '_no']"
                                                :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                      option[item.field.replace('_no', '') + '_name']
                    }`"
                                                :value="option[item.field.replace('_no', '') + '_no']"
                                                :disabled="option.status == 0"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column
                                    title="金额"
                                    v-if="item.field == 'amt' && item.column_status == 1"
                                    :width="item.column_width"
                                    :key="item.field + index"
                                    field="amt"
                                    :edit-render="{}"
                                >
                                    <template v-slot:edit="{ row }">
                                        <span>{{ countAmount(row).toFixed(systemSet.amt) }}</span>
                                    </template>
                                </vxe-table-column>
                            </template>

                            <template #empty>
            <span style="color: red">
              <img src="../../../assets/img/dontHave.png" style="width: 180px" />
            </span>
                            </template>
                        </vxe-table>
                    </div>
                    <!-- 客户存欠 -->
                    <div class="table1" style="flex: 2;">
                        <div class="title">
                            <p>客户存欠（正欠负存）</p>
                        </div>
                        <vxe-table
                            height="440"
                            :data="form.custAccount"
                            ref="custAccountTable"
                            resizable
                            stripe
                            :auto-resize="true"
                            border
                            :mouse-config="{ selected: true }"
                            :scroll-y="{ enabled: true, gt: 50 }"
                            :row-style="rowStyleMethod"
                        >
                            <vxe-table-column title="账期" type="type" field="type" width="50" align="center"></vxe-table-column>
                            <vxe-table-column title="存欠项目" type="style_name" field="style_name" width="100"
                                              align="center"></vxe-table-column>
                            <vxe-table-column title="存欠值" type="value" field="value" width="200" align="center">
<!--                                <template #default="{ row }">-->
<!--                                <span :style="{-->
<!--                                    color: Number(String(row.value).replace(/,/g, '')) >= 0 ? 'green' : 'red',-->
<!--                                    fontWeight: 'bold'-->
<!--                                }">-->
<!--                                    {{ row.value }}-->
<!--                                </span>-->
<!--                                </template>-->
                            </vxe-table-column>
                            <template #empty>
                                <span style="color: red">
                                  <img src="@/assets/img/dontHave.png" style="width: 200px" />
                                </span>
                            </template>
                        </vxe-table>
                    </div>
                </div>
            </div>
        </template>

        <!--   底部汇总数     -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.priceSettledQty') + '：'">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item label="结价金额：">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.unroundedAmt') + '：'">
                        <p>{{ form.sumamt2 }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.subscribe_no)" style="width: 73px"
                >{{ $t('common.cancel') }}</el-button
                >
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItOver">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 导出弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.export')" :visible.sync="excelData.isshow" width="60%">
            <div class="pro" style="text-align: center">
                <el-select
                    style="display: block; width: 50%; margin: 0 auto"
                    v-model="excelValue"
                    clearable
                    default-first-option
                    placeholder="请选择"
                >
                    <el-option label="新结价" value="新结价">新结价</el-option>
                    <el-option label="结价" value="结价">结价</el-option>
                    <el-option label="结价明细" value="结价明细">结价明细</el-option>
                </el-select>
                <el-input style="display: block; width: 50%; margin: 10px auto" v-model="keyword" placeholder="请输入结价单号"></el-input>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="cust_no"
                    v-if="excelValue == '结价'"
                    placeholder="请选择客户"
                >
                    <el-option
                        v-for="(item, index) in allArr.cust"
                        :key="index"
                        :label="item.cust_name"
                        :value="item.cust_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="currency_no"
                    v-if="excelValue == '结价'"
                    placeholder="请选择货币"
                >
                    <el-option
                        v-for="(item, index) in allArr.currency"
                        :key="index"
                        :label="item.kind_name"
                        :value="item.kind_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '结价'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-model="balprc_date"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <div style="display: block; width: 50%; margin: 0 auto 10px" v-if="excelValue == '新结价'">
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="开始日期"
                        v-model="balprc_date"
                        style="width: 100%"
                    ></el-date-picker>
                    <el-date-picker
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="结束日期"
                        v-model="datetimes"
                        style="width: 100%"
                    ></el-date-picker>
                </div>
                <el-select
                    style="display: block; width: 50%; margin: 0 auto 10px"
                    filterable
                    clearable
                    default-first-option
                    v-model="style_no"
                    v-if="excelValue == '结价明细'"
                    placeholder="请选择产品"
                >
                    <el-option
                        v-for="(item, index) in allArr.style"
                        :key="index"
                        :label="item.style_name"
                        :value="item.style_no"
                        :disabled="item.status == 0"
                    ></el-option>
                </el-select>
                <div style="display: flex; align-items: center; margin-top: 30px; justify-content: center">
                    <el-button style="margin-left: 10px" type="success" icon="el-icon-download" @click="outExcel">{{ $t('common.export') }}</el-button>
                    <el-button type="primary" icon="el-icon-download" @click="outTem">模板导出</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="excelData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints" style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="printBox" id="print" ref="print" style="page-break-after: always; padding: 10px; text-align: center">
                <div
                    style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                    v-if="DataDtl.company.is_show == 1"
                >
                    <p class="company" v-if="systemSet.company" :style="`font-size:${DataDtl.company.font_size}px;`">
                        {{ systemSet.company }}
                    </p>
                </div>

                <div v-if="DataDtl.title">
                    <div v-if="DataDtl.title.is_show == 1">
                        <p class="printTitle" v-if="printList.billtype_info" :style="`font-size:${DataDtl.title.font_size}px;`">
                            {{ printList.billtype_info.billtype_name }}
                        </p>
                    </div>
                </div>
                <div v-if="DataDtl.header">
                    <div v-if="DataDtl.header.is_show == 1">
                        <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                            <div>
                                <div v-if="DataDtl.custno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;text-align:left`">
                                    客户编号：{{ printList.cust_no}}
                                </div>
                                <div v-if="DataDtl.custname.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;text-align:left`">
                                    客户：{{ printCust.cust_name }}
                                </div>
                                <div v-if="DataDtl.billremark.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;text-align:left`">
                                    备注：{{ printList.remark }}
                                </div>
                            </div>
                            <div>
                                <div v-if="DataDtl.billno.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;text-align:left`">
                                    单号：{{ printList.balprc_no }}
                                </div>
                                <div v-if="DataDtl.billdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;text-align:left`">
                                    日期：{{ printList.balprc_date }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="DataDtl.is_fields1 == 1" :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`">
                    <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                        <tr align="center">
                            <template v-for="item in fields1">
                                <template v-if="item.is_show == 1">
                                    <th
                                        :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="item.seq"
                                    >
                                        {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                    </th>
                                </template>
                            </template>
                        </tr>
                        <tr align="center" v-for="(item, index) in printDtl" :key="index">
                            <template v-for="items in fields1">
                                <template v-if="items.is_show == 1">
                                    <td
                                        v-if="items.name == '产品名称'"
                                        :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${items.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="items.seq"
                                    >
                                        {{ item.style_info[items.no] || '-' }}
                                    </td>
                                    <td
                                        v-else
                                        :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${items.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                        :key="items.seq"
                                    >
                                        {{ item[items.no] || '-' }}
                                    </td>
                                </template>
                            </template>
                        </tr>
                        <tr align="center">
                            <template v-for="(items, indexs) in fields1">
                                <template v-if="indexs == 0"
                                ><td
                                    :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${items.align};border:${
                                            DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                        }`"
                                    :key="items.seq"
                                >
                                    合计
                                </td></template
                                >
                                <template v-else>
                                    <template v-if="items.is_show == 1">
                                        <td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ dtlTotal[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </template>
                        </tr>
                    </table>
                </div>
                <div v-if="DataDtl.is_tot">
                    <div v-if="DataDtl.is_tot.is_show == 1">
                        <div class="summoney">
                            <div class="sum1">
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">总计 金额大写 {{ printList.money_type }}</span>
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ printList.money_chinese }}</span>
                            </div>
                            <div class="sum1">
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                >金额合计&nbsp;&nbsp;&nbsp;{{ printList.money_type }}</span
                                >
                                <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ printList.money }}</span>
                            </div>
                        </div>
                    </div>
                </div>

<!--                <div v-if="DataDtl.custaccounts_begin">-->
<!--                    <div-->
<!--                        class="sum2"-->
<!--                        v-if="DataDtl.custaccounts_begin.is_show == 1"-->
<!--                        :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"-->
<!--                    >-->
<!--                        <span style="color: rgb(7, 16, 114); font-size: 12px; border-right: 0; font-weight: bold"-->
<!--                        >期初存欠帐（正欠负存）:</span-->
<!--                        >-->
<!--                        <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                            <p-->
<!--                                style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                v-for="(item, index) in printStockStart"-->
<!--                                :key="index"-->
<!--                            >-->
<!--                                <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-if="DataDtl.custaccounts_end">-->
<!--                    <div-->
<!--                        class="sum2"-->
<!--                        v-if="DataDtl.custaccounts_end.is_show == 1"-->
<!--                        :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"-->
<!--                    >-->
<!--                        <span style="color: rgb(7, 16, 114); font-size: 12px; border-right: 0; font-weight: bold"-->
<!--                        >期末存欠帐（正欠负存）:</span-->
<!--                        >-->
<!--                        <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                            <p-->
<!--                                style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                v-for="(item, index) in printStockend"-->
<!--                                :key="index"-->
<!--                            >-->
<!--                                <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-if="DataDtl.custaccounts_now">-->
<!--                    <div-->
<!--                        class="sum2"-->
<!--                        v-if="DataDtl.custaccounts_now.is_show == 1"-->
<!--                        :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
<!--                    >-->
<!--                        <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
<!--                        <div style="display: flex; flex-wrap: wrap; width: 80%">-->
<!--                            <p-->
<!--                                style="width: 25%; display: flex; justify-content: space-between"-->
<!--                                v-for="(item, index) in printList.custaccounts_now"-->
<!--                                :key="index"-->
<!--                            >-->
<!--                                <span style="margin-right: 10px">{{ item.style_name }}</span>-->
<!--                                <span style="font-weight: normal">{{ item.value }}</span>-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                    <div
                        class="sum2"
                        v-for="(accountConfig, index) in sortedCustAccounts"
                        :key="index"
                        v-if="accountConfig && accountConfig.is_show == 1"
                        :style="`font-size:${accountConfig.font_size}px;`"
                    >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                        <div style="display: flex; flex-wrap: wrap; width: 80%">
                            <p style="width: 25%; display: flex; justify-content: space-between"
                               v-for="(item, itemIndex) in printList[accountConfig.dataKey]"
                               :key="itemIndex"
                            >
                                <span style="margin-right: 10px">{{ item.style_name }}</span>
                                <span style="font-weight: normal">{{ item.value }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="DataDtl.footer">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <div class="sumBotn" style="width: 72%; margin-right: 8%">
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>制单：</span>
                                <span v-if="buildHas">{{ buildHas.staffr_name }}</span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>复核：</span>
                                <span></span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>业务员：</span>
                                <span v-if="printList.salesman_report">{{ printList.salesman_report.staffr_name }}</span>
                            </div>
                            <div :style="`font-size:${DataDtl.footer.font_size}px;`" v-show="DataDtl.footer.is_show == 1">
                                <span>客户签名：</span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align: right;">
                    <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                </div>
                <div v-if="DataDtl.remark.is_show == 1">
                    <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">{{ DataDtl.remark.content }}</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiFirstOver,
    apiSearchOver,
    apiLastOver,
    apiNextOver,
    apiPrevOver,
    apiAllSelectOver,
    apiModifyOver,
    apiaddOver,
    apiDelOver,
    apiGetinfo,
    apiCurrentPermisson,
    apicheckOver,
    apiCustOver,
    apiPrintOver,
    apiSystem,
    getPrinOut_pull,
    balprcStypePrice,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiGetCutAccount
} from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
import { formats } from 'vxe-table';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'overprice',
    data() {
        return {
            printType: '',
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            bonusData: { field: [], table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            searchData: [],
            arr: [],
            arrs: [],
            cust_no: '',
            style_no: '',
            currency_no: '',
            balprc_date: '',
            tableData: [],
            activeName: 'first',
            allArr: '',
            form: {},
            isedit: true,
            isCheck: false,
            prev: null,
            next: null,
            outData: { isshow: false, scope: null, index: 0, data: {} },
            excelData: { isshow: false, scope: null, index: 0, data: {} },
            printData: { isshow: false, scope: null, index: 0, data: {} },
            checkData: { isshow: false, scope: null, index: 0, data: {} },
            keyword: '',
            isAdd: false,
            loading: false,
            excelValue: '',
            pull_cust: [],
            pull_sale: [],
            pull_baltype: [],
            pull_curry: [],
            nullBtn: false,
            printList: {},
            printDtl: [],
            printStock: [],
            printStockStart: [],
            printStockend: [],
            dtlTotal: '',
            datetime: '',
            buildHas: '',
            printCust: '',
            printSale: '',
            printBal: '',
            systemSet: '',
            username: '',
            salesman_report: '',
            printType: '结价单',
            datetimes: '',
            dtlIndex: '-1',
            isSave: true,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '30',
            perData: {} //权限
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },
    mounted() {
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    created() {
        // this.getSystem();
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        if (this.$route.query.isadd == 0) {
            // this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            } else {
                this.geData();
            }
        }
        this.getPulls();

        this.getTable();
        this.getPermission();
        document.addEventListener('keydown', this.mykeyup);
    },

    activated() {
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            let bill_no = this.$route.query.bill_no;
            if (bill_no) {
                this.searchIt(bill_no);
            }
        }
    },
    methods: {
        fetchCustAccount(custNo, endDate) {
            const data = {
                custNo: custNo,
                endDate: endDate
            };
            apiGetCutAccount(data).then(res => {
                if (res.code === 2000) {
                    this.form.custAccount = res.data;
                    this.$refs.custAccountTable.loadData(res.data);
                }
            });
        },
        billDateChange(v) {
            this.fetchCustAccount(this.form.cust_no, v);
        },
        selectCustChange(v) {
            this.fetchCustAccount(v, this.form.balprc_date);
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/overprice') {
                        this.saveItOver();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        //获取页面信息-----------------------------------------
        geData() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            this.isedit = true;
            this.isAdd = false;
            apiLastOver({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    }
                } else {
                    loading.close();
                    if (res.data.info == '无数据请先添加' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiAllSelectOver({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.pull_cust = res.data.cust;
                    this.pull_sale = res.data.salesman_no;
                    this.pull_curry = res.data.currency;
                    this.pull_baltype = res.data.baltype;
                    if (this.$route.query.isadd == 0) {
                        this.add();
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //搜索-----------------------------------------------------
        searchIt(no) {
            this.isedit = true;
            apiSearchOver({
                balprc_no: no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    this.outData.isshow = false;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;

            if (no == null) {
                this.geData();
            } else {
                this.searchIt(no);
            }
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/overprice');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEvent(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存修改------------------------------------------
        saveItOver() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? '1' : '0';
                //
                this.$load.show();
                if (this.isAdd == true) {
                    apiaddOver(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/overprice');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyOver(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            this.form = res.data.data;
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { custmtrstock: [], custcurrency: [], balprc_date: '' };
                this.form.check = false;
                this.isCheck = false;
                this.isAdd = true;
                this.nullBtn = false;
                this.form.balprc_date = this.$getTime();

                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 1; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delOver() {
            this.$confirm('确定要删除该结价管理单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelOver({
                        balprc_no: this.form.balprc_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            if (res.data.data == null) {
                                this.form = {};
                                this.nullBtn = true;
                            } else {
                                this.form = res.data.data;
                                if (this.form.check == 1) {
                                    this.isCheck = true;
                                } else {
                                    this.isCheck = false;
                                }
                            }
                            this.next = res.data.next;
                            this.prev = res.data.prev;
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //是否可以编辑修改(审核按钮)------------------------
        isEdit(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apicheckOver({
                balprc_no: this.form.balprc_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                    this.$message.success(res.msg);
                    this.searchIt(this.form.balprc_no);
                } else {
                    this.$message.error(res.data.info);
                    // if (this.form.check == 1) {
                    //     this.form.check = 0;
                    // } else {
                    //     this.form.check = 1;
                    // }
                    this.searchIt(this.form.balprc_no);
                }
            });
        },
        // 跳到第一页-------------------------------------------
        firstPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiFirstOver({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 跳到最后一页-------------------------------------------
        lastPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiLastOver({}).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 下一页-----------------------------------------------------
        nextPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiNextOver({
                balprc_no: this.form.balprc_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 上一页------------------------------------------
        prevPage() {
            const loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrevOver({
                balprc_no: this.form.balprc_no
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.form = res.data.data;
                    this.next = res.data.next;
                    this.prev = res.data.prev;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'style_no');
            // this.$refs.stylefocus.focus();
        },

        //回车事件-----------------------------------------
        enterFilterEvent({ $panel, row }, event) {
            if (event.keyCode === 13) {
                //
                //
                this.$refs.xTable1.insertAt('', -1);
                // $panel.confirmFilter()
            }
        },
        //导出excel----------------------------------------
        showOut() {
            this.excelData.isshow = true;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        outExcel() {
            var name = this.username;

            this.excelData.isshow = false;
            this.$axios
                .get(this.$baseURL + 'balprc_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        login_staff: name,
                        balprc_no: this.keyword,
                        type: this.excelValue,
                        cust_no: this.cust_no,
                        style_no: this.style_no,
                        currency_no: this.currency_no,
                        balprc_date: this.balprc_date,
                        datetime: this.datetimes
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '.xlsx';
                    link.click();
                });
            // }
        },
        //导出模板----------------------------------
        outTem() {
            this.$axios
                .get(this.$baseURL + 'balprc_template_export', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: this.excelValue
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.excelValue + '模板.xlsx';
                    link.click();
                });
        },
        // 行样式方法
        rowStyleMethod({ row }) {
            if (row.type === '实时') {
                return { background: '#fff7e6' } // 浅黄色 - 期初
            } else if (row.type === '本期') {
                return { background: '#e6f7ff' } // 浅蓝色 - 本期
            } else if (row.type === '期末') {
                return { background: '#f6ffed' } // 浅绿色 - 期末
            }
            return {}
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        //列配置相关接口

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '30';
            }
            this.drawers = true;
        },

        checkMove() {},

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '30'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //处理产品名称回显
        formatStyle(value) {
            if (Object.keys(this.allArr).length > 0) {
                if (value) {
                    let bill = this.allArr.style.filter((item) => item.style_no == value);
                    if (bill.length > 0) {
                        return bill[0].style_name;
                    } else {
                        return value;
                    }
                }
            }
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
            if (e == 'dtl') {
                balprcStypePrice({
                    style_no: row.style_no
                }).then((res) => {
                    row.wgt_prc = res.data;
                });
            }
        },
        selectName(row) {
            var newArr = this.allArr.style.filter(function (obj) {
                return obj.style_no == row.row.style_name;
            });
            row.row.style_no = newArr[0].style_no;
        },
        //计算金额小计-------------------------
        countAmount(row) {
            var b = Number(row.qty || 0) * Number(row.qty_prc || 0) + Number(row.wgt || 0) * Number(row.wgt_prc || 0);
            row.amt = b;
            return b;
        },
        //计算金额总计
        countAllAmount(data) {
            return this.$utils.sum(data.map((row) => this.countAmount(row)));
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '34'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // 表尾合计-----------------------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.form.sumwgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                        this.$forceUpdate();
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'qty') {
                        this.form.sumqty = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.qty)} `;
                    } else if (column.property == 'amt') {
                        this.form.sumamt = this.$formatOrderAmt(this.$utils.sum(data, column.property), this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                        // this.form.sumamt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        selectCust(value) {
            if (value) {
                let item = this.allArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
            return;
            apiCustOver({
                cust_no: this.form.cust_no
            }).then((res) => {
                if (res.code == 2000) {
                    this.form.custmtrstock = res.data.custmtrstock;
                    this.form.custcurrency = res.data.custcurrency;
                    this.form.salesman_no = res.data.salesman[0] ? res.data.salesman[0].salesman_no : '';
                    this.$forceUpdate();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        refreshs() {
            this.$forceUpdate();
        },
        // 打印-----------------------
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS(
                //   {
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                //   }
                // )
                //
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('结价管理.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintOver({
                balprc_no: this.form.balprc_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl[0];
                    this.printDtl = this.printList.dtl_report;
                    this.dtlTotal = this.printList.dtl_total;
                    this.printStock = this.printList.custmtrstock;
                    this.printStockStart = this.printList.custaccounts_begin;
                    this.printStockend = this.printList.custaccounts_end;
                    this.datetime = this.printList.datetime;
                    this.buildHas = this.printList.build_has;
                    this.printBal = this.printList.billtype_info;
                    this.printCust = this.printList.cust_info;
                    this.printSale = this.printList.salesman_report;
                    this.salesman_report = this.printList.salesman_report;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },
        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            // this.handleDtl(val);
            this.query.model_name = val;
            // this.printOut();
            this.printOutTwo();
            this.$forceUpdate();
        },
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
                // this.fields2 = JSON.parse(this.DataDtl.fields2);
                // this.fields1 = JSON.parse(this.DataDtl.fields1);
            });
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiPrintOver({
                balprc_no: this.form.balprc_no,
                printId: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.dtl[0];
                    this.printDtl = this.printList.dtl_report;
                    this.dtlTotal = this.printList.dtl_total;
                    this.printStock = this.printList.custmtrstock;
                    this.printStockStart = this.printList.custaccounts_begin;
                    this.printStockend = this.printList.custaccounts_end;
                    this.datetime = this.printList.datetime;
                    this.buildHas = this.printList.build_has;
                    this.printBal = this.printList.billtype_info;
                    this.printCust = this.printList.cust_info;
                    this.printSale = this.printList.salesman_report;
                    this.salesman_report = this.printList.salesman_report;
                    this.DataDtl = res.data.model_data;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.printOut();
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        getRefreshPull() {
            this.pull_cust = this.allArr.cust;
            this.pull_sale = this.allArr.salesman_no;
            this.pull_curry = this.allArr.currency;
            this.pull_baltype = this.allArr.baltype;
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增入库明细
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/overpHistory', query: { page: 'overprice' } });
        },
        handleInput(row, field, type) {
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            var jumps = ['amt']; //非输入框列字段
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;
            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);
            // 最后一列不需要右移
            if (columnIndex + 1 < length) {
                // 获取当前列的下一列
                var downtype = column[columnIndex + 1].property;
                // 不需要填写的跳过
                if (column[columnIndex + 2]) {
                    var downtypes = column[columnIndex + 2].property;
                }
            }

            // 回车键遇到非输入框需要单独处理
            if (e.keyCode == '13' || e.keyCode == '9') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtype);
                }
                if (rowIndex + 1 == rows.length && columnIndex + 1 == length) {
                    this.insertEvent(-1);
                }
            }
            if (e.keyCode == '39') {
                if (jumps.indexOf(downtype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, downtypes);
                } else {
                    if (columnIndex + 1 == length) {
                        if (rowIndex + 1 == rows.length) {
                            this.insertEvent(-1);
                            rows = this.$refs.xTable1.getTableData().fullData;
                            // 换行
                            setTimeout(() => {
                                this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                            }, 100);
                        } else {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }
                        // // 换行
                        // this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    } else {
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                var uptype = column[columnIndex - 1].property;
                // 不需要填写的跳过
                if (column[columnIndex - 2]) {
                    var uptypes = column[columnIndex - 2].property;
                }

                if (jumps.indexOf(uptype) > -1) {
                    this.$refs.xTable1.setActiveCell(row, uptypes);
                } else {
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped></style>
<style lang="scss" scoped>
.el-table__header tr,
.el-table__header th {
    padding: 0;
    height: 22px;
    font-size: 12px;
}
//调整表格高度
.el-table__body tr,
.el-table__body td {
    padding: 0;
    height: 22px;
    font-size: 12px;
}
.printBox table td,
.printBox table th {
    padding: 0;
    height: 22px;
    font-size: 12px;
}
.printBox table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.printBox table td,
.printBox table th {
    border: 1px solid #000;
}
.printBox table th {
    font-weight: bold;
    color: #000;
}
.company {
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}
.printTitle {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    letter-spacing: 25px;
}
.printTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 16px;
    color: #000;
    border-bottom: 1px solid rgb(7, 16, 114);
}
.printTop div label {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.printTop div p {
    line-height: 1.25;
}
.printBox .tableName {
    font-size: 12px;
    padding: 2px 0;
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.oversummoney {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 5px 10px 10px 0;
    border-bottom: 1px solid #000;
}
.oversummoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 15px;
}
.oversummoney .sum1 span:nth-child(2) {
    font-size: 15px;
    color: #000;
    margin-left: 20px;
}
.sum2 {
    border-bottom: 1px solid rgb(7, 16, 114);
    padding: 1px 0;
    display: flex;
    align-items: flex-start;
}
.sum2 p {
    color: #000;
    font-weight: normal;
    border-right: 1px solid #000;
    padding: 0 5px;
}
.sumBotn {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 5px 0;
}
.sumBotn p span {
    font-size: 15px;
    color: #000;
}
.sumBotn div span:first-child {
    color: rgb(7, 16, 114);
    font-weight: bold;
}
.modify {
    background: #eee;
    border-radius: 10px;
    padding-right: 20px;
}
.modify .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
.modify .el-form-item__label {
    padding: 0 0 0 0;
}
.modify .el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0;
    color: #409eff !important;
    padding: 0 0;
}
.modify .el-input.is-disabled .el-input__inner {
    background-color: #eee;
}
.checkboxProOreder {
    margin-top: 5px;
    float: right;
    margin-left: 10px;
}
.checkboxProOreder input[type='checkbox'] {
    width: 17px;
    height: 17px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    position: relative;
}
.checkboxProOreder input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: -3px;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
}
.checkboxProOreder input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #fff;
    position: absolute;
    top: -3px;
    left: 0;
    width: 100%;
    border: 1px solid #e50232;
    color: #e50232;
    font-size: 17px;
    font-weight: bold;
}
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.accountOv .vxe-table .vxe-body--column.col--ellipsis,
.accountOv .vxe-table.vxe-editable .vxe-body--column,
.accountOv .vxe-table .vxe-footer--column.col--ellipsis,
.accountOv .vxe-table .vxe-header--column.col--ellipsis {
    height: 30px;
}
.accountOv .vxe-table .vxe-body--column:not(.col--ellipsis),
.accountOv .vxe-table .vxe-footer--column:not(.col--ellipsis),
.accountOv .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0;
}
.accountOr {
    display: flex;
    align-items: flex-start;
}
.accountOr .vxe-table.size--mini .vxe-body--column.col--ellipsis,
.accountOr .vxe-table.size--mini .vxe-footer--column.col--ellipsis,
.accountOr .vxe-table.size--mini .vxe-header--column.col--ellipsis,
.accountOr .vxe-table.vxe-editable.size--mini .vxe-body--column {
    height: 30px;
}
.accountOr .vxe-table.size--mini .vxe-body--column:not(.col--ellipsis),
.accountOr .vxe-table.size--mini .vxe-footer--column:not(.col--ellipsis),
.accountOr .vxe-table.size--mini .vxe-header--column:not(.col--ellipsis) {
    padding: 5px 0;
}
.accountOv tr.vxe-header--row:first-child {
    background: rgb(128, 0, 0);
    color: #fff;
}
.accountOr div tr.vxe-header--row:first-child {
    background: rgb(64, 128, 128);
    color: #fff;
}
.vxe-table .vxe-footer--column.col--ellipsis:not(.col--actived) .vxe-cell {
    color: red;
}
.overo {
    width: 50%;
}
.overoo {
    width: 50%;
    margin-left: 10px;
}
.el-select {
    width: 100%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
    .accountOr {
        display: inline;
    }
    .overo {
        width: 100%;
    }
    .overoo {
        width: 100%;
        margin-left: 0;
        margin-top: 10px;
    }
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
    .printTop div label,
    .oversummoney .sum1 span:nth-child(1),
    .sumBotn p span {
        font-size: 12px;
    }
}
.sum1 .sum1_tip {
    width: 100%;
    text-align: left;
    color: #000;
    font-size: 14px;
}
.summoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 10px 0 5px;
}

.summoney .sum1 span:nth-child(1) {
    color: rgb(7, 16, 114);
    font-weight: bold;
    font-size: 12px;
}

.summoney .sum1 span:nth-child(2) {
    font-size: 12px;
    color: #000;
    margin-left: 20px;
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
</style>
